<div class="onboarding-overlay" *ngIf="isVisible" (click)="closeModal()" [style.cursor]="currentStep === 5 ? 'pointer' : 'default'">
  <div class="modal-container" [class.step-1-theme]="currentStep === 1 || currentStep === 5" (click)="$event.stopPropagation()">

    <!-- Animation Wrapper -->
    <div class="step-content-wrapper" [class.animating]="isAnimating" [attr.data-direction]="animDirection">

      <!-- SCREEN 1: Welcome Screen -->
      <div class="step-screen step-1" *ngIf="currentStep === 1">
        <div class="screen-content">
          <div class="welcome-text">
            <h1 class="heading">You're in, let's go !</h1>
            <p class="body-text">
              Time to make this experience actually fit you. Add a few details about where you are and where you're
              headed. We'll use it to keep things clear, relevant, and useful at every step.
            </p>
            <button class="btn-primary-yellow" (click)="onLetsGetStarted()">Let's get started</button>
          </div>
          <div class="welcome-illustration">
            <img src="/assets/images/onboarding-welcome.png" alt="Education Illustration">
          </div>
        </div>
      </div>

      <!-- SCREEN 2: About You (Step 1/2) -->
      <div class="step-screen step-2" *ngIf="currentStep === 2">
        <div class="header-bar">
          <div class="title-group">
            <h2>About you</h2>
            <span>Next → Dream Destination</span>
          </div>
          <div class="step-indicator">
            <div class="ring">
              <span class="count">1/2</span>
              <span class="label">steps</span>
            </div>
          </div>
        </div>

        <form [formGroup]="aboutYouForm" class="form-body">
          <div class="form-grid">
            <div class="form-group">
              <label>FIRST NAME <span class="required-asterisk">*</span></label>
              <input type="text" formControlName="firstName" placeholder="e.g. John"
                [class.invalid]="isFieldInvalid(aboutYouForm, 'firstName')">
              <div class="error-msg" *ngIf="isFieldInvalid(aboutYouForm, 'firstName')">
                <span *ngIf="aboutYouForm.get('firstName')?.errors?.['required']">First name is required</span>
                <span *ngIf="aboutYouForm.get('firstName')?.errors?.['minlength']">Must be at least 2 characters</span>
                <span *ngIf="aboutYouForm.get('firstName')?.errors?.['pattern']">Only letters are allowed</span>
              </div>
            </div>
            <div class="form-group">
              <label>LAST NAME <span class="required-asterisk">*</span></label>
              <input type="text" formControlName="lastName" placeholder="e.g. Doe"
                [class.invalid]="isFieldInvalid(aboutYouForm, 'lastName')">
              <div class="error-msg" *ngIf="isFieldInvalid(aboutYouForm, 'lastName')">
                <span *ngIf="aboutYouForm.get('lastName')?.errors?.['required']">Last name is required</span>
                <span *ngIf="aboutYouForm.get('lastName')?.errors?.['pattern']">Only letters are allowed</span>
              </div>
            </div>
            <div class="form-group">
              <label>DATE OF BIRTH <span class="required-asterisk">*</span></label>
              <p-calendar formControlName="dateOfBirth" placeholder="mm-dd-yy" dateFormat="mm/dd/yy" [showIcon]="true"
                [baseZIndex]="3000" [class.invalid]="isFieldInvalid(aboutYouForm, 'dateOfBirth')" appendTo="body">
              </p-calendar>
              <div class="error-msg" *ngIf="isFieldInvalid(aboutYouForm, 'dateOfBirth')">
                <span>Date of birth is required</span>
              </div>
            </div>
            <div class="form-group">
              <label>GENDER <span class="required-asterisk">*</span></label>
              <p-dropdown formControlName="gender" [options]="genderOptions" optionLabel="name" optionValue="value"
                placeholder="Select gender" [baseZIndex]="3000" [filter]="false" [showClear]="true"
                [class.invalid]="isFieldInvalid(aboutYouForm, 'gender')" appendTo="body">
              </p-dropdown>
              <div class="error-msg" *ngIf="isFieldInvalid(aboutYouForm, 'gender')">
                <span>Gender is required</span>
              </div>
            </div>
            <div class="form-group full">
              <label>CURRENT LOCATION <span class="required-asterisk">*</span></label>
              <p-autoComplete formControlName="currentLocation" [suggestions]="locationSuggestions"
                (completeMethod)="searchLocation($event)" field="description" placeholder="Search your location..."
                [baseZIndex]="3000" (onSelect)="onLocationSelect($event)"
                [class.invalid]="isFieldInvalid(aboutYouForm, 'currentLocation')" appendTo="body">
                <ng-template let-prediction pTemplate="item">
                  <div class="white-space-normal" style="word-wrap: break-word;">
                    {{prediction.description}}
                  </div>
                </ng-template>
              </p-autoComplete>
              <div class="error-msg" *ngIf="isFieldInvalid(aboutYouForm, 'currentLocation')">
                <span>Current location is required</span>
              </div>
            </div>
          </div>

          <div class="form-footer">
            <button type="button" class="btn-save-continue" (click)="onNextStep()">
              Save & Continue <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </form>
      </div>

      <!-- SCREEN 3: Your Dream Destination (Step 2/2) -->
      <div class="step-screen step-3" *ngIf="currentStep === 3">
        <div class="header-bar">
          <div class="title-group">
            <h2>Your Dream Destination</h2>
          </div>
          <div class="step-indicator">
            <div class="ring">
              <span class="count">2/2</span>
              <span class="label">steps</span>
            </div>
          </div>
        </div>

        <div class="form-body">
          <form [formGroup]="dreamDestinationForm">
            <div class="countries-section">
              <label>INTENDED COUNTRIES</label>
              <div class="pills-container">
                <button type="button" *ngFor="let country of countryPills" class="pill-btn"
                  [class.selected]="isCountrySelected(country)" (click)="toggleCountry(country)">
                  {{ country }}
                </button>
              </div>
            </div>

            <div class="form-grid">
              <div class="form-group">
                <label>INTENDED LEVEL</label>
                <p-dropdown formControlName="intendedLevel" [options]="levelOptions" optionLabel="name"
                  optionValue="key" placeholder="Select Level" [baseZIndex]="3000" [filter]="false" [showClear]="true"
                  [class.invalid]="isFieldInvalid(dreamDestinationForm, 'intendedLevel')" appendTo="body">
                </p-dropdown>
                <div class="error-msg" *ngIf="isFieldInvalid(dreamDestinationForm, 'intendedLevel')">
                  <span>Intended level is required</span>
                </div>
              </div>
              <div class="form-group">
                <label>FIELD OF INTEREST</label>
                <p-dropdown formControlName="fieldOfInterest" [options]="fieldOfInterestOptions"
                  placeholder="Select Fields" [baseZIndex]="3000" [filter]="false" [showClear]="true" appendTo="body">
                </p-dropdown>
              </div>
              <div class="form-group">
                <label>JOURNEY STAGE</label>
                <p-dropdown formControlName="journeyStage" [options]="journeyStageOptions" optionLabel="name"
                  optionValue="key" placeholder="Select Stage" [baseZIndex]="3000" [filter]="false" [showClear]="true"
                  appendTo="body">
                  <ng-template let-stage pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img [src]="stage.icon" alt=" " width="20" height="20" />
                      <span>{{ stage.name }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="form-group">
                <label>ENROLLMENT YEAR</label>
                <p-dropdown formControlName="enrollmentYear" [options]="enrollmentYearOptions" optionLabel="name"
                  optionValue="key" placeholder="Select Year" [baseZIndex]="3000" [filter]="false" [showClear]="true"
                  appendTo="body">
                </p-dropdown>
              </div>
            </div>
          </form>

          <div class="form-footer">
            <div class="spacer"></div>
            <button type="button" class="btn-skip" (click)="onSkipDreamDestination()">Skip</button>
            <button type="button" class="btn-save-continue" (click)="onNextStep()">
              Save & Continue <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- SCREEN 4: Parent Details -->
      <div class="step-screen step-4" *ngIf="currentStep === 4">
        <div class="header-bar tall">
          <h2>Who are the legends behind you?<br>Tell us about your parents</h2>
        </div>

        <form [formGroup]="parentDetailsForm" class="form-body scrollable">
          <div class="section-label mother">MOTHER'S / GUARDIAN'S DETAILS</div>
          <div class="form-grid">
            <div class="form-group">
              <label>FULL NAME</label>
              <input type="text" formControlName="motherName" placeholder="e.g. Jane Doe"
                [class.invalid]="isFieldInvalid(parentDetailsForm, 'motherName')">
              <div class="error-msg" *ngIf="isFieldInvalid(parentDetailsForm, 'motherName')">
                <span *ngIf="parentDetailsForm.get('motherName')?.errors?.['required']">Full name is required</span>
                <span *ngIf="parentDetailsForm.get('motherName')?.errors?.['pattern']">Only letters are allowed</span>
              </div>
            </div>
            <div class="form-group">
              <label>EMAIL</label>
              <input type="email" formControlName="motherEmail" placeholder="e.g. jane@example.com"
                [class.invalid]="isFieldInvalid(parentDetailsForm, 'motherEmail')">
              <div class="error-msg" *ngIf="isFieldInvalid(parentDetailsForm, 'motherEmail')">
                <span *ngIf="parentDetailsForm.get('motherEmail')?.errors?.['required']">Email is required</span>
                <span *ngIf="parentDetailsForm.get('motherEmail')?.errors?.['email']">Please enter a valid email</span>
              </div>
            </div>
            <div class="form-group">
              <label>MOBILE NUMBER</label>
              <div class="phone-input">
                <input type="text" formControlName="motherPhone" placeholder="1234567890" inputmode="numeric"
                  maxlength="10">
              </div>
              <div class="error-msg" *ngIf="isFieldInvalid(parentDetailsForm, 'motherPhone')">
                <span *ngIf="parentDetailsForm.get('motherPhone')?.errors?.['pattern']">Must be 10 digits</span>
              </div>
            </div>
            <div class="form-group"></div>
          </div>

          <div class="section-label father">FATHER'S DETAILS</div>
          <div class="form-grid">
            <div class="form-group">
              <label>FULL NAME</label>
              <input type="text" formControlName="fatherName" placeholder="e.g. John Doe"
                [class.invalid]="isFieldInvalid(parentDetailsForm, 'fatherName')">
              <div class="error-msg" *ngIf="isFieldInvalid(parentDetailsForm, 'fatherName')">
                <span *ngIf="parentDetailsForm.get('fatherName')?.errors?.['required']">Full name is required</span>
                <span *ngIf="parentDetailsForm.get('fatherName')?.errors?.['pattern']">Only letters are allowed</span>
              </div>
            </div>
            <div class="form-group">
              <label>EMAIL</label>
              <input type="email" formControlName="fatherEmail" placeholder="e.g. john@example.com"
                [class.invalid]="isFieldInvalid(parentDetailsForm, 'fatherEmail')">
              <div class="error-msg" *ngIf="isFieldInvalid(parentDetailsForm, 'fatherEmail')">
                <span *ngIf="parentDetailsForm.get('fatherEmail')?.errors?.['required']">Email is required</span>
                <span *ngIf="parentDetailsForm.get('fatherEmail')?.errors?.['email']">Please enter a valid email</span>
              </div>
            </div>
            <div class="form-group">
              <label>MOBILE NUMBER</label>
              <div class="phone-input">
                <input type="text" formControlName="fatherPhone" placeholder="1234567890" inputmode="numeric"
                  maxlength="10">
              </div>
              <div class="error-msg" *ngIf="isFieldInvalid(parentDetailsForm, 'fatherPhone')">
                <span *ngIf="parentDetailsForm.get('fatherPhone')?.errors?.['pattern']">Must be 10 digits</span>
              </div>
            </div>
            <div class="form-group"></div>
          </div>


          <div class="form-footer">
            <div class="spacer"></div>
            <button type="button" class="btn-skip" (click)="onSkipParents()">Skip</button>
            <button type="button" class="btn-save-continue" (click)="onNextStep()" [disabled]="isSubmitting">
              <span *ngIf="!isSubmitting">Save & Continue <i class="pi pi-chevron-right"></i></span>
              <span *ngIf="isSubmitting"><i class="pi pi-spin pi-spinner"></i> Saving...</span>
            </button>
          </div>
        </form>
      </div>

      <div class="step-screen step-5" *ngIf="currentStep === 5">
        <div class="success-content">
          <div class="check-icon flex justify-content-center">
             <img src="assets/images/application-success.png" alt="Success" style="width: 150px; height: 150px; object-fit: contain;" />
          </div>
          <h1 class="success-title">You're all set now !</h1>
          <p class="success-subtitle">What do you want to do next ?</p>
          <div class="action-cards-container">
            <div class="action-cards">
              <!-- Top Yellow Card -->
              <div class="card primary" (click)="navigateTo('/portal/psychometric-test')">
                <div class="card-icon"><img src="assets/images/pop-up-brain.png" alt="Brain" style="width: 100%; height: 100%; object-fit: contain;"></div>
                <div class="card-text">
                  <h3>Take a Psychometric Test</h3>
                  <span>A stream test or a Career test</span>
                </div>
                <div class="card-arrow"><span class="arrow-circle" style="
    background: white;
    color: #000086;
"><i class="pi pi-arrow-up-right"></i></span></div>
              </div>

              <!-- Bottom White Cards Row -->
              <div class="secondary-row">
                <div class="card outlined" *ngIf="!isFromAppForm" (click)="navigateTo('/portal/application-form')">
                  <div class="card-icon"><img src="assets/images/pop-up-email.png" alt="Email" style="width: 100%; height: 100%; object-fit: contain;"></div>
                  <div class="card-text">
                    <h3>Fill Application Form</h3>
                    <span>View Dashboard</span>
                  </div>
                  <div class="card-arrow"><span class="arrow-circle"><i class="pi pi-arrow-up-right"></i></span></div>
                </div>

                <div class="card outlined" *ngIf="isFromAppForm" (click)="navigateTo('/portal/view-profile/' + userId)">
                  <div class="card-icon"><i class="pi pi-user"></i></div>
                  <div class="card-text">
                    <h3>View Profile</h3>
                    <span>See your profile details</span>
                  </div>
                  <div class="card-arrow"><span class="arrow-circle"><i class="pi pi-arrow-up-right"></i></span></div>
                </div>

                <div class="card outlined" (click)="navigateTo('/portal/mentor-me')">
                  <div class="card-icon"><img src="assets/images/pop-up-mentor.png" alt="Mentor" style="width: 100%; height: 100%; object-fit: contain;"></div>
                  <div class="card-text">
                    <h3>Talk to a mentor</h3>
                    <span>Free 15-min intro call</span>
                  </div>
                  <div class="card-arrow"><span class="arrow-circle"><i class="pi pi-arrow-up-right"></i></span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>